export default "__VITE_ASSET__3cb49339__"